import { m } from 'framer-motion';

import NoSsr from '@mui/material/NoSsr';
import Avatar from '@mui/material/Avatar';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import { useVirtualLogin } from 'src/contexts/virtual-login-context';

import { varHover, AnimateAvatar } from 'src/components/animate';

// ----------------------------------------------------------------------

export function AccountButton({ open, photoURL, displayName, profileImageUrl, sx, ...other }) {
  const theme = useTheme();
  // Get virtual login state for styling virtual user avatar
  const { isVirtualLogin } = useVirtualLogin();

  const renderFallback = (
    <Avatar
      sx={{
        width: 40,
        height: 40,
        border: `solid 2px ${theme.vars.palette.background.default}`,
      }}
    >
      <SvgIcon>
        <circle cx="12" cy="6" r="4" fill="currentColor" />
        <path
          fill="currentColor"
          d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5"
          opacity="0.5"
        />
      </SvgIcon>
    </Avatar>
  );

  return (
    <IconButton
      component={m.button}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      sx={{ p: 0, ...sx }}
      {...other}
    >
      <NoSsr fallback={renderFallback}>
        <AnimateAvatar
          slotProps={{
            avatar: { 
              alt: displayName,
              src: profileImageUrl && profileImageUrl !== '/assets/placeholder.svg' ? profileImageUrl : undefined,
              onError: () => {
                // Handle image load error - fallback to initials
                console.log('Profile image failed to load, using initials');
              }
            },
            overlay: {
              border: isVirtualLogin ? 3 : 1, // Thicker border for virtual login
              spacing: 2,
              // Green gradient for virtual login, default colors for normal login
              color: isVirtualLogin 
                ? `conic-gradient(${theme.vars.palette.success.main}, ${theme.vars.palette.success.light}, ${theme.vars.palette.success.main})`
                : `conic-gradient(${theme.vars.palette.primary.main}, ${theme.vars.palette.warning.main}, ${theme.vars.palette.primary.main})`,
            },
          }}
        >
          {displayName?.charAt(0).toUpperCase()}
        </AnimateAvatar>
      </NoSsr>
    </IconButton>
  );
}
